/* ============
 * Getters for the user module
 * ============
 *
 * The getters that are available on the
 * user module.
 */

export default {
  jwt: state => { return state.jwt },
  exp: state => { return state.exp },
  names: state => { return state.names },
  codeUser: state => { return state.coUs },
  inititalValues: state => { return state.initialValues },
  userInfo: state => { return state.user },
  basicInfo: state => { return state.info },
  polizasInfo: state => { return state.polizas },
  polizasVidaVehicular: state => { return state.polizasVidaVehicular },
  historyPayments: state => { return state.historyPayments },
  electronicDocs: state => { return state.electronicDocs },
  loanRequested: state => { return state.haveLoanRequested },
  niubizSessionKey: state => { return state.niubizSessionKey },
  ipInfo: state => { return state.ip },
  functionsRules: state => { return state.functions },
  extraInfo: state => { return state.extra },
  /**
   * Retorna el flag que controla la habilitación de Vive+ desde el backend
   * @returns {boolean} true si Vive+ está habilitado, false en caso contrario
   */
  viveMasEnabled: state => {
    if (state.functions && state.functions.viveMasHabilitado !== undefined) {
      return state.functions.viveMasHabilitado
    }
    return true
  },
  prestamosVidaDisponibilidad: state => state.prestamosVidaDisponibilidad,
  prestamosVidaHabilitado: state => {
    return !!(state.prestamosVidaDisponibilidad && state.prestamosVidaDisponibilidad.prestamoVidaHabilitado)
  },
  /**
   * true si el usuario tiene al menos una solicitud PRESTAMO_VIDA en estado CREADO.
   * Independiente de prestamosVidaHabilitado (visibilidad menú/banner/CTA).
   */
  tieneSolicitudPrestamoVidaEnEvaluacion: state => {
    return !!(state.prestamosVidaDisponibilidad &&
      state.prestamosVidaDisponibilidad.tieneSolicitudEnEvaluacion)
  },
  prestamosVidaPorPoliza: state => numeroPoliza => {
    if (!state.prestamosVidaDisponibilidad || !state.prestamosVidaDisponibilidad.polizas) {
      return null
    }
    return state.prestamosVidaDisponibilidad.polizas.find(
      p => p.numeroPoliza === numeroPoliza
    ) || null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js